/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EFiscalItemDto
 */
export interface EFiscalItemDto {
    /**
     * Receipt transaction IDs (usually single UUID)
     * @type {Array<string>}
     * @memberof EFiscalItemDto
     */
    idTransakcji: Array<string>;
    /**
     * E-fiscal item type
     * @type {number}
     * @memberof EFiscalItemDto
     */
    Type: number;
    /**
     * JWS signed document
     * @type {string}
     * @memberof EFiscalItemDto
     */
    JWS: string;
    /**
     * JPK ID
     * @type {string}
     * @memberof EFiscalItemDto
     */
    jpkid: string;
    /**
     * Payment method number
     * @type {string}
     * @memberof EFiscalItemDto
     */
    pmno: string;
    /**
     * Print status
     * @type {boolean}
     * @memberof EFiscalItemDto
     */
    printStatus: boolean;
    /**
     * Base64-encoded visualization (PNG)
     * @type {string}
     * @memberof EFiscalItemDto
     */
    WizualizacjaBase64: string;
}

/**
 * Check if a given object implements the EFiscalItemDto interface.
 */
export function instanceOfEFiscalItemDto(value: object): value is EFiscalItemDto {
    if (!('idTransakcji' in value) || value['idTransakcji'] === undefined) return false;
    if (!('Type' in value) || value['Type'] === undefined) return false;
    if (!('JWS' in value) || value['JWS'] === undefined) return false;
    if (!('jpkid' in value) || value['jpkid'] === undefined) return false;
    if (!('pmno' in value) || value['pmno'] === undefined) return false;
    if (!('printStatus' in value) || value['printStatus'] === undefined) return false;
    if (!('WizualizacjaBase64' in value) || value['WizualizacjaBase64'] === undefined) return false;
    return true;
}

export function EFiscalItemDtoFromJSON(json: any): EFiscalItemDto {
    return EFiscalItemDtoFromJSONTyped(json, false);
}

export function EFiscalItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EFiscalItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'idTransakcji': json['idTransakcji'],
        'Type': json['Type'],
        'JWS': json['JWS'],
        'jpkid': json['jpkid'],
        'pmno': json['pmno'],
        'printStatus': json['printStatus'],
        'WizualizacjaBase64': json['WizualizacjaBase64'],
    };
}

export function EFiscalItemDtoToJSON(value?: EFiscalItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'idTransakcji': value['idTransakcji'],
        'Type': value['Type'],
        'JWS': value['JWS'],
        'jpkid': value['jpkid'],
        'pmno': value['pmno'],
        'printStatus': value['printStatus'],
        'WizualizacjaBase64': value['WizualizacjaBase64'],
    };
}

